import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'text-input-dialog',
  templateUrl: 'text-input-dialog.component.html',
  styleUrls: ["./text-input-dialog.component.scss"]
})
export class TextInputDialog {
  _working: boolean;
  _value: string;
  error: string;

  set working(value: boolean) {
    this._working = value;
    this.dialogRef.disableClose = value;
  };

  get working(): boolean {
    return this._working;
  };

  set value(value: string) {
    this.error = null;
    this._value = value;
  }

  get value(): string {
    return this._value;
  }

  constructor(public dialogRef: MatDialogRef<TextInputDialog>,
    @Inject(MAT_DIALOG_DATA) public data: TextInputDialogData) {
    this.working = false;
    this.error = null;
    this.value = data.value;
  }

  handleClick(button: TextInputDialogButtonDefinition) {
    if(this.working || (this.error && button.disableIfError) || !this.likesValue(button))
      return;
    this.working = true;
    const value: string = this.value;
    this.error = null;
    Promise.resolve(button.handler(value)).then((error: string) => {
      if(error) {
        this.error = error;
        this.working = false;
      } else {
        if(!button.keepOpen) {
          this.dialogRef.close(button.returnsValue ? {
            error: false,
            result: value
          } as TextInputDialogResult : null);
        }
        if(button.clearDialog) {
          this.value = null;
        }
        this.working = false;
      }
    }, (error: any) => {
      this.dialogRef.close({
        error: true,
        result: error
      } as TextInputDialogResult);
      this.working = false;
    });
  }

  submit() {
    if(this.data.buttons.length == 0)
      return;
    this.handleClick(this.data.buttons[this.data.buttons.length - 1]);
  }

  likesValue(button: TextInputDialogButtonDefinition) {
    return !button.valueIsValid || button.valueIsValid(this.value);
  }

  getDialogContainerStyles(): string {
    return (this.data && this.data.minWidth) ? ('min-width:' + this.data.minWidth + ';') : '';
  }
}

export interface TextInputDialogData {
  title: string;
  body?: string;
  placeholder: string;
  number?: boolean;
  value?: string;
  buttons: TextInputDialogButtonDefinition[];
  minWidth?: string;
}

export interface TextInputDialogButtonDefinition {
  text: string;
  class: string;
  returnsValue?: boolean;
  keepOpen?: boolean;
  clearDialog?: boolean;
  disableIfError?: boolean;
  valueIsValid?: (value: string) => boolean;
  handler: (value: string) => string | Promise<string>;
}

export interface TextInputDialogResult {
  error: boolean;
  result: any;
} 
